module.exports = __webpack_public_path__ + "img/dropdown-blob-grey.921bdd1b.svg";